import eventRegistry from "../event-registry";
import InterceptorsManage from "./interceptorsManage";
/**
 * 仿照axios做的基于promise websocket请求对象 可以实现请求拦截
 * 请求参数: config {
 *  eventName // 事件名称
 *  requestFn // websocket 请求函数
 *  retryConfig: {
 *    num // 当前重试次数
 *    max // 最大重试次数
 *  }
 * }
 * 请求拦截器 interceptors.request.use()
 * 响应拦截器 interceptors.respone.use()
 */

class HstRequest {
  constructor () {
    this.interceptors = {
      request: new InterceptorsManage(),
      response: new InterceptorsManage()
    } 
  }
  request (config)   {
    let chain = [this.sendMessge.bind(this),undefined];

    this.interceptors.request.handlers.forEach(interceptor => {
      chain.unshift(interceptor.onFulField,interceptor.onRejected);
    })

    this.interceptors.response.handlers.forEach(interceptor => {
      chain.push(interceptor.onFulField, interceptor.onRejected)
    })
    let promise = Promise.resolve(config);
    while (chain.length > 0){
      promise = promise.then(chain.shift(),chain.shift());
    }
    return promise;
  }

  sendMessge( config ) {
    return new Promise((resolve, reject) => {
      eventRegistry.on(config.eventName, function(res) {
        resolve({
          data: res,
          config
        });
      });
      config.requestFn()
    });
  }
}
export default HstRequest
